// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SomYvO5l7Iz1na {\n  padding: 0 12px;\n  word-break: break-word;\n}\n.SomYvO5l7Iz1na p {\n  margin: 0 0 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmContainer": "SomYvO5l7Iz1na"
};
export default ___CSS_LOADER_EXPORT___;
